<template>
  <div class="grid grid-cols-2 sm:grid-cols-4 gap-8">
    <div
      class="overflow-hidden bg-[#282733] rounded-[2rem]"
      v-for="(tv, i) in tvs"
      :key="i"
      @click="watchTv(tv)"
    >
      <div class="relative py-[25%] bg-[#3A384A]">
        <div
          class="absolute w-full h-full p-4 top-0 left-0"
          :style="{ backgroundColor: tv.backgroundColor }"
        >
          <img
            :src="tv.logo"
            class="w-full h-full object-contain rounded-xl"
            alt=""
          />
        </div>
      </div>
      <div class="p-4">
        <div class="flex justify-between items-center">
          <div>
            <div class="text-lg font-bold">
              {{ tv.name }}
            </div>
            <div class="opacity-20 text-sm">+100 Regardent</div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import tvs from "@/utils/raws/tvs.json"

export default defineComponent({
  name: 'TvList',
  components: {},
  props: {},
  data() {
    return {
      tvs,
      eventsIds: [],
    }
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    watchTv(tv){
      this.$emit('watchTvRequested', tv)
    }
  },
  computed: {},
})
</script>

